export default "__VITE_ASSET__B3Mp2Jfw__"